import { hyperLink } from '@uiw/codemirror-extensions-hyper-link';
import ReactCodeMirror, { EditorView, type ReactCodeMirrorProps } from '@uiw/react-codemirror';

import { cn } from '@blockworks/ui/system';

const extensions: ReactCodeMirrorProps['extensions'] = [
    EditorView.lineWrapping,
    EditorView.theme({
        '&.cm-editor.cm-focused': {
            outline: '1px solid var(--color-surface-selected)',
        },
        '&.cm-editor': { backgroundColor: 'transparent' },
        '&.cm-editor .cm-content': { backgroundColor: 'transparent' },
    }),
    EditorView.editorAttributes.of({
        class: '[&_.cm-scroller]:scroller',
    }),
    hyperLink,
];

const BASIC_SETUP: ReactCodeMirrorProps['basicSetup'] = {
    lineNumbers: false,
    highlightActiveLine: false,
    foldGutter: false,
};

type MarkdownEditorProps = {
    markdown: string;
    onChange: (value: string) => void;
    placeholder?: string;
    editorProps?: { className?: string };
};

const MarkdownEditor = ({ markdown, onChange, placeholder, editorProps = {} }: MarkdownEditorProps) => {
    return (
        <ReactCodeMirror
            onChange={onChange}
            value={markdown}
            autoFocus
            style={{ outline: 'none' }}
            height="100%"
            width="100%"
            className={cn('border bg-surface w-full h-full', editorProps.className)}
            placeholder={placeholder}
            extensions={extensions}
            basicSetup={BASIC_SETUP}
        />
    );
};

export { MarkdownEditor };
